"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("../../styles/components/_hero.scss");
var dropdown_1 = __importDefault(require("../dropdown"));
var Filter = /** @class */function (_super) {
  __extends(Filter, _super);
  function Filter(props) {
    var _this = _super.call(this, props) || this;
    _this.handleChangeSearch = function (e) {
      _this.setState({
        searchTerm: e.target.value
      });
      _this.props.handleChangeSearch && _this.props.handleChangeSearch(e.target.value);
    };
    _this.state = {
      selectedSortBy: _this.props.sortList[0],
      searchTerm: ''
    };
    return _this;
  }
  Filter.prototype.render = function () {
    var _a = this.props,
      sortList = _a.sortList,
      sortByTitle = _a.sortByTitle,
      sortByValue = _a.sortByValue,
      sortOrder = _a.sortOrder,
      numOfFilters = _a.numOfFilters,
      classname = _a.classname,
      children = _a.children;
    return react_1.default.createElement("div", {
      className: (0, classnames_1.default)('filters', classname)
    }, numOfFilters < 4 && react_1.default.createElement("div", {
      className: 'level'
    }, react_1.default.createElement("div", {
      className: 'level-left'
    }, react_1.default.createElement(dropdown_1.default, {
      title: sortByTitle,
      list: sortList,
      sortByValue: sortByValue,
      sortOrder: sortOrder,
      onChange: this.props.handleChangeSort,
      onChangeSortOrder: this.props.handleChangeSortOrder
    }), children), react_1.default.createElement("div", {
      className: 'level-right'
    }, react_1.default.createElement("div", {
      className: 'field has-addons .is-flex-mobile'
    }, react_1.default.createElement("p", {
      className: 'control'
    }, react_1.default.createElement("input", {
      className: 'input',
      type: 'text',
      value: this.state.searchTerm,
      onChange: this.handleChangeSearch,
      placeholder: 'Enter movie name'
    })), react_1.default.createElement("p", {
      className: 'control'
    }, react_1.default.createElement("a", {
      className: 'button is-static'
    }, "Search"))))), numOfFilters > 3 && react_1.default.createElement("div", {
      className: 'level'
    }, react_1.default.createElement("div", {
      className: 'level-item'
    }, react_1.default.createElement(dropdown_1.default, {
      title: sortByTitle,
      list: sortList,
      sortByValue: sortByValue,
      onChange: this.props.handleChangeSort
    })), children, react_1.default.createElement("div", {
      className: 'level-item'
    }, react_1.default.createElement("div", {
      className: 'field has-addons .is-flex-mobile'
    }, react_1.default.createElement("p", {
      className: 'control'
    }, react_1.default.createElement("input", {
      className: 'input',
      type: 'text',
      value: this.state.searchTerm,
      onChange: this.handleChangeSearch,
      placeholder: 'Enter movie name'
    })), react_1.default.createElement("p", {
      className: 'control'
    }, react_1.default.createElement("a", {
      className: 'button is-static'
    }, "Search"))))));
  };
  Filter.defaultProps = {
    numOfFilters: 2
  };
  return Filter;
}(react_1.PureComponent);
exports.default = Filter;